import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { User } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useDeptChairs() {
	return useQuery<User[]>({
		queryKey: ['get-dept-chairs', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('users')
				.select('user_first, user_last, user_id, user_firebase_id')
				.eq('school_id', schoolId)
				.eq('user_role', 'dept')
				.order('user_first', { ascending: true });

			if (error) throw error;

			return (data ?? []) as unknown as User[];
		},

		staleTime: Infinity,
	});
}
